import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate("/login", { replace: true }); // ✅ Redirige correctamente
  }, [logout, navigate]);

  return (
    <div>
      Logging out... {/* Muestra un mensaje temporal */}
    </div>
  );
};

export default Logout;
